<template>
  <div class="user-manage">
    <!-- 添加标题栏 -->
    <div class="page-header">
      <div class="title">
        <i class="el-icon-user"></i>
        <span>用户管理</span>
      </div>
    </div>

    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="部门名称">
          <el-cascader
            v-model="searchForm.department"
            :options="departmentList"
            :props="{ checkStrictly: true }"
            clearable
            placeholder="请选择部门"
            class="filter-item">
          </el-cascader>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="searchForm.username" placeholder="请输入用户名称" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="searchForm.phone" placeholder="请输入手机号码" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="用户状态" class="filter-item">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>

      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <!-- <el-button type="success" icon="el-icon-edit" @click="handleModify">修改</el-button> -->
        <!-- <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete" :disabled="true">删除</el-button> -->
      </div>

      <!-- 用户列表 -->
      <el-table :data="tableData" style="width: 100%" border stripe @selection-change="handleSelectionChange"
      v-loading="tableLoading" element-loading-text="加载中...">
        <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column prop="loginName" label="登录名称" align="center"></el-table-column>
        <el-table-column prop="username" label="真实姓名" align="center"></el-table-column>
        <el-table-column prop="department" label="部门" align="center">
          <template slot-scope="{row}">
            {{ row.department }}
          </template>
        </el-table-column>
        <el-table-column prop="postName" label="岗位" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号码" width="120" align="center"></el-table-column>
        <el-table-column prop="weUserId" label="企微" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.weUserId || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'info'">
              {{ scope.row.status === '1' ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" @click="handleResetPwd(scope.row)">重置</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
            <el-button v-if="!scope.row.weUserId" type="text" @click="handleBindWework(scope.row)">绑定企微</el-button>
            <el-button v-if="scope.row.weUserId" type="text" @click="handleUnbindWework(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 统一的用户表单对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body>
      <el-form :model="userForm" :rules="rules" ref="userForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="真实姓名" prop="nickname" required>
              <el-input v-model="userForm.nickname" placeholder="请输入用户昵称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="department" required>
              <el-cascader
                v-model="userForm.department"
                :options="departmentList"
                :props="{ checkStrictly: true }"
                placeholder="请选择归属部门"
                style="width: 100%">
            </el-cascader>
             
              <!-- <el-select
                v-model="userForm.department"
                placeholder="请选择归属部门"
                filterable
                clearable
                style="width: 100%"
                >
                <el-option
                  v-for="item in departmentList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select> -->


            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone" required>
              <el-input v-model="userForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email" required>
              <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户名称" prop="username" required>
              <el-input v-model="userForm.username" placeholder="请输入用户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 新增时显示密码输入框，修改时不显示 -->
            <el-form-item v-if="!isEdit" label="用户密码" prop="password" required>
              <el-input v-model="userForm.password" type="password" placeholder="请输入用户密码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户性别">
              <el-select v-model="userForm.gender" placeholder="请选择" style="width: 100%">
                <el-option label="男" value="male"></el-option>
                <el-option label="女" value="female"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="userForm.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="岗位">
              <el-select
                v-model="userForm.position"
                placeholder="请选择岗位"
                filterable
                clearable
                style="width: 100%"
                @focus="handlePositionFocus">
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色">
              <el-select
                v-model="userForm.role"
                placeholder="请选择角色"
                filterable
                clearable
                style="width: 100%"
                @change="handleRoleChange">
                <el-option
                  v-for="item in roleList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="userForm.remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 企微用户选择器对话框 -->
    <el-dialog
      title="绑定企微用户"
      :visible.sync="weworkDialogVisible"
      width="600px"
      append-to-body>
      <div v-loading="weworkTreeLoading" element-loading-text="加载中...">
        <el-tree
          ref="weworkTree"
          :data="weworkTreeData"
          :props="weworkTreeProps"
          node-key="key"
          :default-expand-all="false"
          :expand-on-click-node="false"
          @node-click="handleWeworkNodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <i :class="data.type === 'department' ? 'el-icon-folder' : 'el-icon-user'"></i>
              {{ node.label }}
              <el-tag v-if="data.type === 'user' && data.disabled" size="mini" type="info">已绑定</el-tag>
            </span>
          </span>
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="weworkDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!selectedWeworkUser" @click="confirmBind">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'UserManage',
  data() {
    return {
      tableLoading: false,
      disabled:false,
      searchForm: {
        department: '',
        username: '',
        phone: '',
        status: ''
      },
      tableData: [],
      multipleSelection: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增用户',
      isEdit: false, // 是否是编辑模式
      userForm: {
        id: '', // 新增时为空，修改时有值
        nickname: '',
        department: '',
        phone: '',
        email: '',
        username: '',
        password: '',
        gender: '',
        status: '1',
        position: '',
        role: '',
        remark: ''
      },
      rules: {
        nickname: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请选择归属部门', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        password: [
          { required: false, message: '请输入用户密码', trigger: 'blur' }
        ]
      },
      departmentList: [],
      positionList: [], // 岗位列表
      positionLoading: false, // 岗位加载状态
      positionQuery: '', // 岗位搜索关键字
      roleList: [], // 角色列表
      roleMenus: [], // 存储当前选择角色的菜单权限
      // 企微绑定相关
      weworkDialogVisible: false,
      weworkTreeData: [],
      weworkTreeLoading: false,
      weworkTreeProps: {
        children: 'children',
        label: 'title',
        disabled: 'disabled'
      },
      selectedWeworkUser: null,
      currentBindingUser: null
    }
  },
  methods: {
    handleSearch() {
      this.currentPage = 1
      this.pageSize = 10
     this.fetchUserList()
    },
    handleReset() {
      this.searchForm = {
        department: '',
        username: '',
        phone: '',
        status: ''
      }
      this.currentPage = 1
      this.fetchUserList()
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增用户'
      this.userForm = {
        id: '',
        username: '',
        nickname: '',
        department: '',
        phone: '',
        email: '',
        password: '',
        gender: 'male',
        status: '1',
        position: '',
        role: '',
        remark: '',
        
      }
      this.dialogVisible = true
      // this.$nextTick(() => {
      //   if (this.$refs.userForm) {
      //     this.$refs.userForm.clearValidate()
      //   }
      // })
    },
    handleModify() {
      if (this.multipleSelection.length !== 1) {
        this.$message.warning('请选择一条记录进行修改')
        return
      }
      this.handleEdit(this.multipleSelection[0])
    },
    handleEdit(row) {
      console.log('编辑行数据:', row) // 添加日志
      this.isEdit = true
      this.dialogTitle = '修改用户'
      this.userForm = {
        id: row.id,
        userId: row.userId,
        username: row.loginName,
        nickname: row.username,
        // 修改这里：如果后端返回的是完整的部门路径数组，直接使用
        department: row.departmentId ? [row.departmentId] : [],  
        phone: row.phone || '',
        email: row.email || '',
        password: '',
        gender: row.sex === 1 ? 'male' : 'female',
        status: row.status.toString(),
        position: row.postId,
        role: row.roleId,
        remark: row.remark || ''
      }
      this.dialogVisible = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchUserList()
    },
    handleCurrentChange(val) {
      console.log('页码改变:', val)  // 添加日志
      this.currentPage = val
      this.fetchUserList()
    },
    submitForm() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          try {
            // 构造请求参数
            const params = {
              userId: this.userForm.id || '', // 新增时为空，修改时有值
              userName: this.userForm.username,
              realName: this.userForm.nickname,
              deptId: Array.isArray(this.userForm.department) ? 
              this.userForm.department[this.userForm.department.length - 1] : 
              this.userForm.department,
              phone: this.userForm.phone,
              email: this.userForm.email,
              sex: this.userForm.gender === 'male' ? 1 : 2,
              state: parseInt(this.userForm.status || '1'),
              postId: this.userForm.position,
              roleId: this.userForm.role,
              remark: this.userForm.remark || '',
              status: -1
            }
            
            console.log('提交的参数:', params) // 添加日志

            // 新增时才传密码
            if (!this.isEdit && this.userForm.password) {
              params.password = this.userForm.password
            }

            const res = await request({
              url: '/api/v1/user/save',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: params
            })

            if (res.status === 1) {
              this.$message.success(this.isEdit ? '修改用户成功' : '新增用户成功')
              this.dialogVisible = false
              this.fetchUserList()
            } else {
              this.$message.error(res.msg || (this.isEdit ? '修改用户失败' : '新增用户失败'))
            }
          } catch (error) {
            console.error(this.isEdit ? '修改用户错误:' : '新增用户错误:', error)
            this.$message.error(this.isEdit ? '修改用户失败' : '新增用户失败')
          }
        }
      })
    },
    async handleResetPwd(row) {
    console.log(row)
      try {
        await this.$confirm(`确认重置用户"${row.loginName}"的密码?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/v1/user/reset-password/${row.id}`,
          method: 'POST',
          data: {
            userId: row.id,
            password: 'Aa@123456'
          }
        })
        
        if (res.status === 1) {
          this.$message.success('密码重置成功，默认密码为：Aa@123456')
        } else {
          this.$message.error(res.msg || '密码重置失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('重置密码错误:', error)
          this.$message.error('密码重置失败')
        }
      }
    },
    // 获取部门列表
    async fetchDepartmentList() {
      try {
        const res = await request({
          url: '/api/v1/dept/list',
          method: 'POST',
          data: {
            name: '',
            status: -1
          }
        })
        
        if (res.status === 1) {
          console.log('部门列表原始数据:', res.data) // 添加日志
          this.departmentList = this.formatDepartmentData(res.data)
          console.log(this.departmentList)
          



        }
      } catch (error) {
        console.error('获取部门列表错误:', error)
        this.$message.error('获取部门列表失败')
      }
    },
    formatDepartmentData(list) {
      // 格式化每个部门项
      const formattedList = list.map(item => ({
        id: item.dept_id,
        parentId: item.parent_id,
        label: item.dept_name,
        value: item.dept_id,
        children: []
       
      }))

      // 构建树形结构
      const tree = []
      const map = {}

      // 创建映射关系
      formattedList.forEach(item => {
        map[item.id] = item
      })

      formattedList.forEach(item => {
        const parent = map[item.parentId]
        if (parent && item.parentId !== '0') {
          // 有父节点且不是顶级节点
          parent.children.push(item)
        } else {
          // 顶级节点直接加入树中
          tree.push(item)
        }
      })

      return tree
    },
    // 获取岗位列表
    async fetchPositionList(query = '') {
      try {
        const res = await request({
          url: '/api/v1/posts/list',
          method: 'POST',
          data: {
            postName: query,
            postCode: '',
            status: -1,
            page: 1,
            limit: 50  // 增加数量以显示更多选项
          }
        })
        
        if (res.status === 1) {
          this.positionList = res.data.map(item => ({
            label: item.postName,
            value: item.postId
          }))
        }
      } catch (error) {
        console.error('获取岗位列表错误:', error)
        this.$message.error('获取岗位列表失败')
      }
    },
    // 处理岗位选择器获得焦点
    handlePositionFocus() {
      // 当选择器获得焦点时加载岗位列表
      // if (this.positionList.length === 0) {
      //   this.fetchPositionList()
      // }
    },
    // 获取角色列表
    async fetchRoleList() {
      try {
        const res = await request({
          url: '/api/v1/role/list',
          method: 'POST',
          data: {
            name: '',
            roleKey: '',
            status: 1,
            page: this.currentPage,
           
          }
        })
        
        if (res.status === 1) {
          this.roleList = res.data.list.map(item => ({
            label: item.RoleName,
            value: item.RoleID
          }))
        }
      } catch (error) {
        console.error('获取角色列表错误:', error)
        this.$message.error('获取角色列表失败')
      }
    },
    // 处理角色选择器获得焦点
    handleRoleFocus() {
      if (this.roleList.length === 0) {
        this.fetchRoleList()
      }
    },
    // 获取用户列表数据
    async fetchUserList() {
      this.tableData = []
      this.tableLoading = true

      try {
        const res = await request({
          url: '/api/v1/user/list',
          method: 'POST',
          data: {
            page: this.currentPage,
            size: this.pageSize,
            department: this.searchForm.department,
            username: this.searchForm.username,
            phone: this.searchForm.phone,
            status: this.searchForm.status
          }
        })
        
        if (res.status === 1) {
          // 确保当前页码与后端返回的数据一致
          this.currentPage = res.data.page || this.currentPage
          this.tableData = res.data.list.map(item => {
            // 根据 deptId 在部门列表中查找对应的部门信息
            const deptInfo = this.findDepartmentPath(item.deptId)
            return {
              id: item.userId,
              loginName: item.userName,
              username: item.realName,
              // 使用找到的部门路径
              department: deptInfo ? deptInfo.path : '未分配部门',
              departmentId: item.deptId,
              phone: item.phone,
              email: item.email,
              status: item.state.toString(),
              createTime: item.createAt,
              roleId: item.roleId,
              roleName: item.roleName,
              postName: item.postName || '未知',
              postId: item.postId,
              weUserId: item.weUserId || ''
            }
          })
          this.total = res.data.total
        } else {
          this.$message.error(res.msg || '获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表错误:', error)
        this.$message.error('获取用户列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    // 添加一个方法用于根据 deptId 查找部门路径
    findDepartmentPath(deptId) {
      const findPath = (list, targetId, parentPath = []) => {
        for (const item of list) {
          const currentPath = [...parentPath, item.label]
          if (item.id === deptId) {
            return {
              path: currentPath.join('/'),
              deptName: item.label
            }
          }
          if (item.children && item.children.length) {
            const result = findPath(item.children, targetId, currentPath)
            if (result) return result
          }
        }
        return null
      }
      return findPath(this.departmentList, deptId)
    },
    // 删除单个用户
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/v1/user/delete`,
          method: 'POST',
          data: {
            userId: row.id
          }
        })
        
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchUserList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除用户错误:', error)
          this.$message.error('删除失败')
        }
      }
    },

    // 批量删除用户
    // async handleBatchDelete() {
    //   if (this.multipleSelection.length === 0) {
    //     this.$message.warning('请选择要删除的记录')
    //     return
    //   }

    //   try {
    //     await this.$confirm('确认删除选中的用户?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     })
        
    //     const userIds = this.multipleSelection.map(item => item.id)
    //     const res = await request({
    //       url: '/api/v1/users/delete/:id',
    //       method: 'POST',
    //       data: userIds
    //     })
        
    //     if (res.status === 1) {
    //       this.$message.success('批量删除成功')
    //       this.fetchUserList()
    //     } else {
    //       this.$message.error(res.msg || '批量删除失败')
    //     }
    //   } catch (error) {
    //     if (error !== 'cancel') {
    //       console.error('批量删除用户错误:', error)
    //       this.$message.error('批量删除失败')
    //     }
    //   }
    // },

    // 修改密码
    async handleChangePassword() {
      try {
        const res = await request({
          url: '/api/v1/user/change-password',
          method: 'POST',
          data: {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            confirmPassword: this.confirmPassword
          }
        })
        
        if (res.status === 1) {
          this.$message.success('密码修改成功')
        } else {
          this.$message.error(res.msg || '密码修改失败')
        }
      } catch (error) {
        console.error('修改密码错误:', error)
        this.$message.error('密码修改失败')
      }
    },

    // 退出登录
    async handleLogout() {
      try {
        const res = await request({
          url: '/api/v1/logout',
          method: 'POST'
        })
        
        if (res.status === 1) {
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          this.$router.push('/login')
          this.$message.success('退出成功')
        } else {
          this.$message.error(res.msg || '退出失败')
        }
      } catch (error) {
        console.error('退出登录错误:', error)
        this.$message.error('退出失败')
      }
    },

    // 当角色选择改变时触发
    async handleRoleChange(roleId) {
      try {
        // 获取该角色的菜单权限
        const response = await request.post('/api/v1/role/permissions/list', {
          roleId: roleId
        })
        
        if (response.data && response.status === 1) {
          this.roleMenus = response.data.menuIds || []
          // 重新过滤菜单树
          this.filterMenuTree()
        }
      } catch (error) {
        console.error('获取角色菜单权限失败:', error)
        this.$message.error('获取角色菜单权限失败')
      }
    },

    // 过滤菜单树
    filterMenuTree() {
      if (!this.$refs.menuTree) return

      const allNodes = this.$refs.menuTree.store.nodesMap
      for (const nodeKey in allNodes) {
        const node = allNodes[nodeKey]
        // 如果节点不在角色菜单权限中,则禁用该节点
        if (!this.roleMenus.includes(node.data.id)) {
          node.disabled = true
        } else {
          node.disabled = false
        }
      }
    },

    // 加载企微数据
    async loadWeworkData() {
      this.weworkTreeLoading = true
      try {
        const [deptRes, userRes] = await Promise.all([
          request({
            url: '/api/v1/wework/sync/departments',
            method: 'GET'
          }),
          request({
            url: '/api/v1/wework/sync/users',
            method: 'GET',
            params: { page: 1, size: 200 }
          })
        ])

        if (deptRes.status === 1 && userRes.status === 1) {
          const departments = deptRes.data.list || []
          const users = userRes.data.list || []

          // 检查是否有数据
          if (departments.length === 0 || users.length === 0) {
            this.$message.warning('暂无企微数据，请联系管理员同步企微组织架构')
            this.weworkDialogVisible = false
            return
          }

          this.weworkTreeData = this.buildWeworkTree(departments, users)
        } else {
          this.$message.error('加载企微数据失败')
        }
      } catch (error) {
        console.error('加载企微数据错误:', error)
        this.$message.error('加载企微数据失败')
      } finally {
        this.weworkTreeLoading = false
      }
    },

    // 构建企微树形结构
    buildWeworkTree(departments, users) {
      // 1. 创建部门节点映射
      const deptMap = {}
      const tree = []

      departments.forEach(dept => {
        deptMap[dept.deptId] = {
          key: `dept_${dept.deptId}`,
          title: dept.deptName,
          type: 'department',
          selectable: false,
          children: [],
          ...dept
        }
      })

      // 2. 建立部门层级关系
      departments.forEach(dept => {
        const node = deptMap[dept.deptId]
        if (dept.parentId === '0' || !deptMap[dept.parentId]) {
          tree.push(node)
        } else {
          deptMap[dept.parentId].children.push(node)
        }
      })

      // 3. 将用户挂载到主部门
      users.forEach(user => {
        const mainDeptId = user.mainDepartment
        if (deptMap[mainDeptId]) {
          const userNode = {
            key: `user_${user.userId}`,
            title: `${user.name}${user.position ? ` (${user.position})` : ''}`,
            type: 'user',
            selectable: !user.sysUserId,
            disabled: !!user.sysUserId,
            isLeaf: true,
            userData: user
          }
          deptMap[mainDeptId].children.push(userNode)
        }
      })

      return tree
    },

    // 处理绑定企微按钮点击
    async handleBindWework(row) {
      this.currentBindingUser = row
      this.selectedWeworkUser = null
      this.weworkDialogVisible = true
      await this.loadWeworkData()
    },

    // 处理树节点点击
    handleWeworkNodeClick(data) {
      if (data.type === 'user' && !data.disabled) {
        this.selectedWeworkUser = data.userData
      } else {
        this.selectedWeworkUser = null
      }
    },

    // 确认绑定
    async confirmBind() {
      if (!this.selectedWeworkUser || !this.currentBindingUser) {
        this.$message.warning('请先选择企微用户')
        return
      }

      try {
        const res = await request({
          url: '/api/v1/wework/sync/bindings',
          method: 'POST',
          data: {
            sysUserId: this.currentBindingUser.id,
            weworkUserId: this.selectedWeworkUser.userId
          }
        })

        if (res.status === 1) {
          this.$message.success('绑定成功')
          this.weworkDialogVisible = false
          this.fetchUserList()
        } else {
          this.$message.error(res.msg || '绑定失败')
        }
      } catch (error) {
        console.error('绑定企微用户错误:', error)
        this.$message.error('绑定失败')
      }
    },

    // 处理解绑操作
    async handleUnbindWework(row) {
      try {
        await this.$confirm(`确认解除 ${row.username} 的企微绑定吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: `/api/v1/wework/sync/bindings/${row.id}`,
          method: 'DELETE'
        })

        if (res.status === 1) {
          this.$message.success('解绑成功')
          this.fetchUserList()
        } else {
          this.$message.error(res.msg || '解绑失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('解绑企微用户错误:', error)
          this.$message.error('解绑失败')
        }
      }
    }
  },
  created() {
    this.fetchDepartmentList()
    this.fetchPositionList()
    this.fetchRoleList()
    this.fetchUserList()
  }
}
</script>

<style lang="scss" scoped>
.user-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .page-header {
    position: relative;
    height: 80px;
    margin: -20px -20px 20px;  // 修改margin以适应布局
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    overflow: hidden;

    /* 添加科技感背景 */
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
      background-size: 20px 20px;
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
      animation: backgroundMove 20s linear infinite;
    }

    /* 添加动态光效 */
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -150%;
      width: 150%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      transform: skewX(-20deg);
      animation: shine 8s infinite;
    }

    .title {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      
      i {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #fff;
        backdrop-filter: blur(5px);
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
    }
  }

  /* 添加动画 */
  @keyframes backgroundMove {
    0% {
      background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    }
    100% {
      background-position: -20px -20px, -20px -10px, -10px -30px, -30px -20px;
    }
  }

  @keyframes shine {
    0% {
      left: -150%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 100%;
    }
  }

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .card-title {
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .card-title i {
    margin-right: 8px;
    color: #409EFF;
  }

  .filter-item {
    width: 200px;
  }

  .filter-buttons {
    margin-left: 10px;
  }

  .operation-bar {
    margin: 20px;
  }

  .el-table {
    margin: 0;
  }

  :deep(.el-table td) {
    padding: 12px 0;
  }

  :deep(.el-table th) {
    padding: 12px 0;
    background-color: #f5f7fa;
  }

  .pagination-container {
    padding: 20px;
    text-align: right;
    background: #fff;
  }

  .el-button + .el-button {
    margin-left: 10px;
  }

  :deep(.el-tag) {
    margin: 0;
    padding: 0 12px;
    height: 28px;
    line-height: 26px;
  }

  // 企微树形选择器样式
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    i {
      margin-right: 8px;
      font-size: 16px;
    }

    .el-tag {
      margin-left: 8px;
    }
  }

  :deep(.el-tree) {
    max-height: 400px;
    overflow-y: auto;
  }
}
</style>
